import { Component } from '@angular/core';
import { Settings } from './shared/settings';
import { LoadingService } from './shared/services/loading.service';
import { LoadingComponent } from './components/loading/loading.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'tenfield-frontend';

  constructor(
    private loadingService: LoadingService
  ){
    console.log(Settings.version);
  }

  public OnLoadingLoaded(loading: LoadingComponent): void {
    this.loadingService.Initialize(loading);
  }
}
